'use client';

import { useEffect } from 'react';

interface UseHeaderRouteEffectsParams {
  onCartClose: () => void;
  onDropdownClose: () => void;
  pathname: string | null;
}

const useHeaderRouteEffects = ({
  onCartClose,
  onDropdownClose,
  pathname,
}: UseHeaderRouteEffectsParams) => {
  useEffect(() => {
    onDropdownClose();
    onCartClose();
  }, [onCartClose, onDropdownClose, pathname]);
};

export default useHeaderRouteEffects;
